const BASE_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://api.pople.credit/api/v1/credit/'
    : 'https://api-dev.pople.credit/api/v1/credit/';
    
// const BASE_URL = 'http://localhost:8080/api/v1/credit/'

export { BASE_URL };

